export const img0 = require("./00_auststellung.jpg");
